import { Grid2 } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WhiteLabelGeneralTabProps as Props } from './types';
import { FaviconPreview } from './components/favicon-preview';
import { LoadingPreview } from './components/loading-preview';
import { HeaderLogo } from './components/header-logo';
import { MenuLeftPreview } from './components/menu-left-preview';
import { ProfileDashboardPreview } from './components/profile-dashboard-preview';
import { NotificationPreview } from './components/notification-preview';

export const WhiteLabelGeneralTab = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('GeneralTab', className)}
      sx={SX.root}
    >
      <Grid2 container columns={24} rowGap={2} columnSpacing={3}>
        <Grid2 xs={24}>
          <FaviconPreview />
        </Grid2>
        <Grid2 xs={10}>
          <LoadingPreview />
        </Grid2>
        <Grid2 xs={14}>
          <HeaderLogo />
        </Grid2>
        <Grid2 xs={10}>
          <Grid2 container xs={12} rowGap={2}>
            <MenuLeftPreview />
            <NotificationPreview />
          </Grid2>
        </Grid2>
        <Grid2 xs={14}>
          <ProfileDashboardPreview />
        </Grid2>
      </Grid2>
    </Styled.Wrapper>
  );
});

WhiteLabelGeneralTab.displayName = 'GeneralTab';
